module.exports = __webpack_public_path__ + "img/chatbot6.d1a12c04.svg";